module.exports = __webpack_public_path__ + "img/stats.adc3761b.svg";